import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  gap: 8px;
  min-width: 220px;
  font-size: 13px;
  line-height: 1.4;
`;

export const Group = styled.div`
  display: grid;
  gap: 6px;
`;

export const GroupLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  opacity: 0.7;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font: inherit;
`;

export const OptionText = styled.span`
  font: inherit;
`;
